import { render, staticRenderFns } from "./index.vue?vue&type=template&id=797a9649&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=797a9649&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797a9649",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('797a9649')) {
      api.createRecord('797a9649', component.options)
    } else {
      api.reload('797a9649', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=797a9649&scoped=true", function () {
      api.rerender('797a9649', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaginsControl/index.vue"
export default component.exports